var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col-md-3"},[_vm._v("Linked Clients")]),_c('div',{staticClass:"col-md-9"},[_c('vue-good-table',{ref:"customerContacts",attrs:{"columns":_vm.customerColumns,"rows":_vm.customers,"totalRows":_vm.customers.length,"pagination-options":{
                  enabled: true,
                  perPage: 10,
                  dropdownAllowAll: false
                },"styleClass":"vgt-table striped bordered"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }